import { RecentsController } from './recents.controller'

function recents () {
  return {
    scope: {
      modalState: '<',
      allowedAssetExtensionsSelection: '<',
      singleAttach: '<',
      removeExtensions: '<',
      showOnlyExtension: '<'
    },
    restrict: 'E',
    templateUrl: '/repository/directives/recents/recents.html?$$REVISION$$',
    controller: RecentsController
  }
}

export { recents }
